/**
 * Clone mode.
 */
export enum CloneMode {
  /** Ignore clone. */
  Ignore,
  /** Assignment clone. */
  Assignment,
  /** Shallow clone. */
  Shallow,
  /** Deep clone. */
  Deep
}
